import { render, staticRenderFns } from "./FontGlobalForm.vue?vue&type=template&id=2c61dbff"
import script from "./FontGlobalForm.vue?vue&type=script&lang=js"
export * from "./FontGlobalForm.vue?vue&type=script&lang=js"
import style0 from "./FontGlobalForm.vue?vue&type=style&index=0&id=2c61dbff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports